import { useSearchParams } from 'react-router-dom';
import { useCallback, useMemo, useState } from 'react';

export const useTableSearch = () => {
  const [params, setParams] = useSearchParams();

  // Get searchQuery from URL
  const searchQuery = params.get('search') || '';
  const [localSearchState, setLocalSearchState] = useState(searchQuery);

  // Get pagination from URL
  const paginationModel = useMemo(
    () => ({
      page: parseInt(params.get('page') || '0', 10),
      pageSize: parseInt(params.get('pageSize') || '20', 10),
    }),
    [params]
  );

  // Set searchQuery in URL
  const setSearchQuery = useCallback(
    (query) => {
      setParams((prev) => {
        if (query) {
          prev.set('search', query);
        } else {
          prev.delete('search');
        }
        // Reset to first page when search changes
        prev.set('page', '0');
        return prev;
      });
    },
    [setParams]
  );

  // Set paginationModel in URL
  const setPaginationModel = useCallback(
    (model) => {
      setParams((prev) => {
        prev.set('page', model.page.toString());
        prev.set('pageSize', model.pageSize.toString());
        return prev;
      });
    },
    [setParams]
  );

  return {
    searchQuery,
    paginationModel,
    setSearchQuery,
    setPaginationModel,
    
    // use it as an input state
    localSearchState,
    setLocalSearchState
  };
};
